import request from '@/utils/httpClient'
import { QuotationCreateParams, QuotationUpdateParams } from '@/types/domain/quotation'

// 创建报价单
export function createQuotation(data: QuotationCreateParams) {
  return request({
    url: 'quotation',
    method: 'POST',
    data
  })
}

// 更新报价单
export function updateQuotation(id: number, data: QuotationUpdateParams) {
  return request({
    url: `quotation/${id}`,
    method: 'put',
    data
  })
}
